import { Box, Button, Flex, Heading } from 'ui'
import { ModalLink } from 'components/ModalLink'
import { InfoLineItem } from './InfoLineItem'
import { BriefcaseIcon, HourglassIcon } from 'lucide-react'
import { useWorkerProfileContext } from '../context/WorkerProfileProvider'

export function ShiftStats() {
  const { state: profile } = useWorkerProfileContext()

  return (
    <Box width={1} py={3}>
      <Heading level={4}>Shifts at {profile.companyName}</Heading>
      <InfoLineItem
        icon={<BriefcaseIcon size={20} />}
        label={'Total Shifts'}
        value={profile.worker.numShiftsForCompany}
      />
      <InfoLineItem
        icon={<HourglassIcon size={20} />}
        label={'Total Hours'}
        value={profile.worker.numHoursForCompany}
      />
      <InfoLineItem
        icon={<HourglassIcon size={20} />}
        label={'Hours in the Last 7 Days'}
        value={profile.worker.numHoursForCompanyPastWeek}
      />
      <Flex justifyContent={'flex-end'} mt={4}>
        <ModalLink to={`/workers/${profile.worker.id}/shifts`}>
          <Button variant={'secondary'} kind={'medium'}>
            View All Shifts
          </Button>
        </ModalLink>
      </Flex>
    </Box>
  )
}
